// Icons
import ExploreIcon from '@material-ui/icons/Explore';
import EmailIcon from '@material-ui/icons/Email';
import BusinessIcon from '@material-ui/icons/Business';
import PersonIcon from '@material-ui/icons/Person';

import Home from './components/Home/Home'
import Enquiries from './components/Enquiries/Enquiries'
import Offices from './components/Offices/Offices'
import Users from './components/Users/Users'

export default {
  items: [{
      path: '/',
      name: 'Home',
      type: 'link',
      icon: ExploreIcon,
      component: Home,
      adminRights: false
    },
  	{
      path: '/enquiries',
      name: 'Enquiries',
      type: 'link',
      icon: EmailIcon,
  		component: Enquiries,
      adminRights: false
  	},
    {
      path: '/offices',
      name: 'Offices',
      type: 'link',
      icon: BusinessIcon,
      component: Offices,
      adminRights: false
    },
    {
      path: '/users',
      name: 'Users',
      type: 'link',
      icon: PersonIcon,
      component: Users,
      adminRights: true
    }
  ]
};


// WEBPACK FOOTER //
// ./src/routes.js